// Polyfill for Promise.withResolvers (ES2024) - needed for react-pdf on older mobile browsers
// @ts-ignore Property 'withResolvers' does not exist on type 'PromiseConstructor' in older TS
if (typeof (Promise as any).withResolvers === "undefined") {
  (Promise as any).withResolvers = function <T>() {
    let resolve: (value: T | PromiseLike<T>) => void;
    let reject: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve: resolve!, reject: reject! };
  };
}

export {};
